/*
window.autoDigitalOrderOnLogin - устанавливается в true при вызове модалки авторизации кнопкой "Оформить заказ"
со страницы электронной корзины. Сбрасывается при закрытии модалки авторизации, если не установлена переменная
window.preventResettingAutoDigitalOrderOnLogin.
По этой переменной будет определяться, нужно ли автоматически сделать заказ после авторизации на странице корзины
электронного контента.

window.preventResettingAutoDigitalOrderOnLogin - запрещает сброс переменной window.autoDigitalOrderOnLogin
при переключении между модалками авторизации: по телефону или по соцсети/логину. Поскольку при переключении модалок тоже
происходит событие fancybox - beforeClose, запрещаем сброс переменной window.autoDigitalOrderOnLogin при таком
переключении 

// ToDo описать новые переменные onLoginBubbleToEmailCollector onLoginBubbleToSubscription onLoginBubbleToGiftBuy
 */

// ToDo получилось немало дублирования кода, нужно отрефакторить или вообще переписать эти формы
(function () {
    $ (function () {
    
        // открытие новой модалки авторизации
        $ (document).on ('click', '[data-fancybox-custom-href="auth"]', (event) => {
            event.preventDefault ()
            window.preventCleanProductToFavourites = true
            if (window.autoDigitalOrderOnLogin) {
                window.preventResettingAutoDigitalOrderOnLogin = true;
            }
            const contentType = event.target.dataset.contentType || 'default';
            showAuthModal ('modalLogin', contentType);
        })
    
        // открытие старой модалки авторизации
        $ (document).on ('click', '[data-fancybox-custom-href="authOld"]', (event) => {
            event.preventDefault ()
            window.preventCleanProductToFavourites = true
            if (window.autoDigitalOrderOnLogin) {
                window.preventResettingAutoDigitalOrderOnLogin = true;
            }
            showAuthModal ('modalLoginOld')
        })
    
        // вызывается с кнопки добавления в избранное, если не авторизованы
        $ (document).on ('needShow:popupLogin', function (event, contentType = 'default') {
            showAuthModal ('modalLogin', contentType)
        })
    
        // показ новой или старой модалки авторизации
        // используется для решения показа книги в левом блоке модалки
        function showAuthModal (id, contentType = 'default') {
            const $modalAuth = $ ('#' + id)
            if ($modalAuth.length === 0) return false
            let settings = {
                beforeLoad: (instance, slide) => {
                    
                    // подмена ссылки на оферту АД на страницах лектория и электронной корзины
                    const offerLink = $modalAuth[0].querySelector('[data-role="offer-link"]')
                    if (offerLink && (window.location.pathname.startsWith('/personal/basket/digital/') || window.location.pathname.startsWith('/lectorii/'))) {
                        offerLink.href = '/contract-offer-ad/';
                    }
                    
                    // обработка левого блока при добавлении в избранное
                    const dataFav = window.productToFavourites
                    if (dataFav && dataFav.isUserNoAuth) {
                        $modalAuth.addClass ('_showBook')
                        $modalAuth.find ('[name="fav-product"]').val (dataFav.offerId)
                    
                        if (dataFav.imgs && (Object.keys (dataFav.imgs).length > 0 && dataFav.imgs.constructor === Object && dataFav.imgs.x3)) {
                            // если объект обложек книг передан и есть хотя бы x3, показываем картинку
                            let srcset =
                                (dataFav.imgs.x3) ? dataFav.imgs.x3 + " 3x, " : "" + (dataFav.imgs.x2) ? dataFav.imgs.x2 + " 2x, " : "" + dataFav.imgs.x1
                            $modalAuth.find ('.js-modal-login__book-img').each ((index, element) => {
                                const $element = $ (element)
                                $element.find ('source').attr ('srcset', srcset)
                                $element.find ('img').attr ('src', dataFav.imgs.x3)
                                $element.removeAttr ('style')
                            })
                            $modalAuth.find ('.js-modal-login__book-img-placeholder').css ('display', 'none')
                        } else {
                            // если картинок нет, показываем плейсхолдер
                            $modalAuth.find ('.js-modal-login__book-img').each ((index, element) => {
                                const $element = $ (element)
                                $element.find ('source').attr ('srcset', '')
                                $element.find ('img').attr ('src', '')
                                $element.css ('display', 'none')
                            })
                            $modalAuth.find ('.js-modal-login__book-img-placeholder').removeAttr ('style')
                        }
                    } else {
                        $modalAuth.removeClass ('_showBook')
                        $modalAuth.find ('[name="fav-product"]').removeAttr ('value')
                    }
    
                    window.onLoginBubbleToSubscription = false;
                    window.onLoginBubbleToGiftBuy = false;
                    if (contentType === 'giftBuy') {
                        window.onLoginBubbleToGiftBuy = true;
                        
                        $modalAuth.find('.js-form-auth-phone .mod-header').html(
                            `<div class="mod-title">Войдите или зарегистрируйтесь</div>`
                        );
                        $modalAuth.find('.js-form-auth-phone .mod-footer').hide();
                        
                    } else if (contentType === 'subscribe') {
                        window.onLoginBubbleToSubscription = true;
                        
                        $modalAuth.find('.js-form-auth-phone .mod-header').html(
                            `<div class="mod-title">Войдите или зарегистрируйтесь</div>`
                        );
                        $modalAuth.find('.js-form-auth-phone .mod-footer').hide();
                        
                    } else if (contentType === 'lectureOrder') {
                        $modalAuth.find('.js-form-auth-phone .mod-header').html(
                            `<div class="mod-title">Войдите или зарегистрируйтесь</div>
                            <p class="mod-p">
                                Это необходимо для покупок в Лектории
                            </p>`
                        );
                        $modalAuth.find('.js-form-auth-phone .mod-footer').hide();
                        
                    } else if (contentType === 'beforeReviewAdd') {
                        $modalAuth.find('.js-form-auth-phone .mod-header').html(
                            `<div class="mod-title">Войдите или зарегистрируйтесь, чтобы оставить отзыв</div>
                            <p class="mod-p">
                                Введите Ваш номер телефона, на&nbsp;который мы&nbsp;отправим код
                            </p>`
                        );
                        $modalAuth.find('.js-form-auth-phone .mod-footer').hide();
                        
                    } else if (contentType === 'simple') {
                        $modalAuth.find('.js-form-auth-phone .mod-header').html(
                            `<div class="mod-title">Войдите или зарегистрируйтесь</div>`
                        );
                        $modalAuth.find('.js-form-auth-phone .mod-footer').hide();
                        
                    } else {
                        $modalAuth.find('.js-form-auth-phone .mod-header').html(
                            `<div class="mod-title">${window.user.userLogged ? 'Добавить телефон в аккаунт' : 'Войдите, чтобы сэкономить'}</div>
                            <p class="mod-p">
                                Экономьте до&nbsp;30% с&nbsp;нашей программой лояльности, доступной только авторизованным пользователям
                            </p>`
                        );
                        $modalAuth.find('.js-form-auth-phone .mod-footer').show();
                    }
                    
                    window.preventCleanProductToFavourites = undefined
                    window.preventResettingAutoDigitalOrderOnLogin = undefined;
                },
                beforeClose: (instance) => {
                    if (!window.preventCleanProductToFavourites) {
                        window.productToFavourites = undefined
                    }
                    if (!window.preventResettingAutoDigitalOrderOnLogin) {
                        window.autoDigitalOrderOnLogin = undefined;
                    }
                    
                    const select = instance.slides[0].$content[0].querySelector('[data-role="phone-input-select"]');
                    if (select && select.classList.contains('tooltipstered')) {
                        $(select).tooltipster('close');
                    }
                }
            }
            
            // Костыль нужен для того, чтобы при открытии окна авторизации по телефону не закрывалось окно с добавлением отзыва.
            // Иначе форма отправки отзыва не отрабатывает свои состояния. К тому же, проблема будет, если нужно ввести капчу
            // TODO убрать, когда будет глобально исправлено поведение модалок при открытии
            if (contentType === 'reviewAdd') {
                settings.closeExisting = false;
            }
            
            $modalAuth.iModalOpen (settings);
        }
    
        // модалка авторизации по телефону
        $ ('.js-form-auth-wrapper').each ((index, element) => {
            const $root = $ (element)
            const $errorPhone = $root.find ('.js-form-auth-phone__errors')
            const $errorCode = $root.find ('.js-form-auth-code__errors')
        
            // сейчас ошибки могут приходить в 2 форматах
            // 1. 'phone: Неверный формат;' - ошибка конкретного параметра
            // 2. 'Код неверный' - просто текст ошибки
            // Связано с тем, что по сайту в разных формах разный формат ошибок
            // Пока в форме авторизации по телефону есть только привязка к коду phone и показ сообщения
            // todo
            // привести к единому формату, возможно, сразу все формы на сайте
        
            // показ ошибки в телефоне
            $root.find ('.js-form-auth-phone')
                .on ('error', (event, response) => {
                    let isErrorShown = false
                    if (response && response.errorMessage && typeof response.errorMessage === 'string') {
                        // ошибки по параметрам приходят с символом ; на конце
                        const errors = response.errorMessage.split (';')
                        if (errors.length > 1) {
                            // ищем ошибку с ключом phone
                            for (let iter = 0; iter < errors.length && !isErrorShown; iter++) {
                                const thisError = errors[iter].split (':')
                                if (thisError.length > 1 && thisError[0] === 'phone') {
                                    showError ($errorPhone, 'Неверный формат телефона')
                                    isErrorShown = true
                                }
                            }
                        } else {
                            // если в строке нет символа ';', то показываем ошибку как есть
                            showError ($errorPhone, response.errorMessage)
                            isErrorShown = true
                        }
                    }
                    if (!isErrorShown) {
                        showError ($errorPhone)
                    }
                })
                .on ('message', (event, message) => {
                    showError ($errorPhone, message);
                })
        
            // показ ошибки в коде
            $root.find ('.js-form-auth-code')
                .on ('error', (event, response) => {
                    if (response && response.errorMessage && typeof response.errorMessage === 'string') {
                        showError ($errorCode, response.errorMessage)
                    } else {
                        showError ($errorCode)
                    }
                })
                .on ('message', (event, message) => {
                    showError ($errorCode, message);
                })
        
            function showError ($obj, message = 'Произошла ошибка', ) {
                const errorHTML = `<div class="ui-alert ui-alert_danger mod-form__errors-item">${message}</div>`;
                $obj.html(errorHTML);
            }
        
            // очистка ошибки
            const cleanError = function ($obj) {
                $obj.html('');
            }
            $root.find ('.js-form-auth-phone')
                .on ('submit', function() {
                    cleanError($errorPhone);
                    cleanError($errorCode);
                })
            $root.find ('.js-form-auth-code')
                .on ('submit codeNeedResend phoneNeedChange', function() {
                    cleanError($errorPhone);
                    cleanError($errorCode);
                })
        })
    
        
        // при передаче в твиг параметра loginReminder сохранится кука loginReminderStart с таймштампом для показа попапа с призывом
        // кука loginReminderDisabled - запрет показа модалки с напоминанием. При закрытии модалки устанавливается запрет на показ на 30 дней
        
        // добавить телефон
        $ ('#modalLoginReminder').each ((index, element) => {
            const $root = $ (element)
            // триггер показа модалки для сбора телефона
            if ($root.data ('login-reminder') && $.cookie ('loginReminderDisabled') === undefined && $.cookie ('loginReminderStart') === undefined) {
                $.cookie ('loginReminderStart', new Date (), {expires: 7, path: '/'})
            }
        })
        
        if ($.cookie ('loginReminderDisabled') === undefined) {
            // при наличии куки loginReminderStart, через 30 секунд покажется попап-ремайндер
            const reminderInterval = setInterval (function () {
                if ($.cookie ('loginReminderStart')) {
                    const diff = (Math.abs (new Date () - new Date ($.cookie ('loginReminderStart')))) / 1000
                    if (diff >= 30) {
                        clearInterval (reminderInterval)
                        $.removeCookie ('loginReminderStart', {path: '/'})
                        $ ('#modalLoginReminder').iModalOpen ({
                            beforeClose: (instance, current, event) => {
                                let cookieExpires = 30
                                // условие для определения, что окно закрыто кликом на кнопку-крестик
                                // if (event && $(event.target).closest('[data-fancybox-close]').length > 0) {
                                $.cookie ('loginReminderDisabled', '1', {expires: cookieExpires, path: '/'})
                            },
                            closeExisting: false,
                        })
                    }
                }
            }, 5000)
        }
    });
    
    function checkPreventReloadOnLogin() {
        return window.onLoginBubbleToBasket
            || (window.onLoginBubbleToOrderPromo && window.discountAvailableOnFirstOrder)
            || (window.onLoginBubbleToSubscription)
            || (window.onLoginBubbleToGiftBuy)
            || (window.onLoginBubbleToEmailCollector);
    }
    
    $ (function () {
        // для хранения капчи V2
        let widgetCaptcha
    
        // форма авторизации / регистрации по телефону
        $ ('.js-form-auth-wrapper').each ((index, element) => {
            const $root = $ (element)
            let widgetCaptcha
        
            // специфичное для формы ввода номера телефона
            $root.find ('.js-form-auth-phone').each ((index, element) => {
                const $form = $ (element)
                const $input = $form.find ('[name="phone"]')
                const $submit = $form.find ('button[type="submit"]')
                const $errors = $form.find('.js-form-auth-phone__errors');
                const emptyFieldClass = 'ui-input-bordered_state-empty';
                const errorFieldClass = 'ui-input-bordered_state-error';
                
                
                const validatePhone = function() {
                    const isEmpty = $input.val() === '';
                    const isValid = $input.inputmask('isComplete');
                    if (isEmpty) {
                        showErrorPhone('Заполните это поле');
                    } else if (!isValid && !$input.hasClass(errorFieldClass)) {
                        showErrorPhone();
                    } else if (isValid) {
                        if ($input.hasClass(errorFieldClass)) {
                            hideErrorPhone();
                        }
                    }
                    return isValid;
                }
                
                const showErrorPhone = function(text = 'Некорректный номер телефона') {
                    $input.trigger('inputError', [{text: text}]);
                }
                
                const hideErrorPhone = function() {
                    $input.trigger('inputResolveErrors');
                }
    
                $input.on("input", function () {
                    if ($input.hasClass(emptyFieldClass)) {
                        $input.removeClass(emptyFieldClass);
                    }
                    if ($input.hasClass(errorFieldClass)) {
                        validatePhone();
                    }
                });
    
                $input.on("blur", function () {
                    validatePhone();
                });
                
                $submit.on ('click', (event) => {
                    event.preventDefault ()
    
                    const isValidPhone = validatePhone();
                    if (isValidPhone) {
                        $form.find ('input').attr ('readonly', true)
                        $form.find ('[type="submit"]').attr ('disabled', true)
                        $form.trigger ('submit')
    
                        // Вызывается аналитическое событие
                        if (!('userLogged' in window.user && window.user.userLogged)) {
                            const analyticsEvent = new CustomEvent('ab.analytics.event', {
                                bubbles: true,
                                cancelable: true,
                                detail: {
                                    eventCode: 'authRequestCode',
                                }
                            });
                            event.target.dispatchEvent(analyticsEvent);
                        }
                    }
                })
            
                $form
                    .on ('submit', event => {
                        $form.trigger ('phoneEnter', [$form.find ('[name="phone"]').val ()])
                        $form.trigger ('phoneCodeEnter', [$form.find ('[name="phone-code"]').val ()])
                    })
                    .on ('success', (event, response) => {
                        
                        // Событие успешной отправки формы телефона
                        // ab.auth.form.phone.success
                        $form.trigger('ab.auth.form.phone.success', {
                            evSuccess: event,
                            response: response
                        });
                        
                        $form.css ('display', 'none')
                        // Бэк может вернуть сообщение с ошибкой, несмотря на успешную отправку формы.
                        // Используется в кейсе, когда нужно показать сообщение ошибки "На этот номер код уже отправлен",
                        // но перейти на форму ввода кода
                        if (response.errorMessage) {
                            $root.find('.js-form-auth-code').trigger('message', [response.errorMessage]);
                        }
                    })
            
                // запрос ввода другого номера
                $ (document).on ('phoneNeedChange', '.js-form-auth-code', (event) => {
                    $form.removeAttr ('style')
                    $form.find ('input').attr ('readonly', false)
                    $form.find ('[type="submit"]').attr ('disabled', false)
                    $input.focus ()
                })
            
                // отправка другого кода
                $ (document).on ('codeNeedResend', '.js-form-auth-code', (event) => {
                    $submit.attr ('disabled', false).trigger ('click')
                })
            })

            // специфичное для формы ввода кода
            $root.find ('.js-form-auth-code').each ((index, element) => {
                const $form = $ (element)
                const $footer = $form.find('.js-form-auth-code__footer');
                const $submit = $form.find('.js-form-auth-code__submit');
                const $changePhone = $form.find ('.js-form-auth-code__phone-change')
                let lastPhoneVal
                let lastPhoneCodeVal
                let timer
                let isResend = false;
                const emptyFieldClass = 'ui-input-bordered_state-empty';
                const errorFieldClass = 'ui-input-bordered_state-error';
                
                const $phoneCode = $form.find ('.js-form-auth-code__code');
                const codeField = new UICodeField($phoneCode[0], {
                    charsCount: 4,
                    mask: "\\d",
                    hiddenInputName: "code",
                    attrs: {
                        autocomplete: 'one-time-code',
                        inputmode: 'numeric',
                        pattern: '[0-9]*',
                    }
                });
                const $input = $phoneCode.find ('[name="code"]');
                
                if ('OTPCredential' in window) {
                    window.addEventListener('DOMContentLoaded', e => {
                        if (!$input) return;
                        const ac = new AbortController();
                        navigator.credentials.get({
                            otp: { transport:['sms'] },
                            signal: ac.signal
                        }).then(otp => {
                            $input.val(otp.code);
                        }).catch(err => {
                            console.log(err);
                        });
                    });
                }
    
                const validateCode = function() {
                    const isEmpty = $input.val() === '';
                    if (isEmpty) {
                        codeField.focusNextInput();
                    }
                    return !isEmpty;
                }
    
                $submit.on ('click', event => {
                    event.preventDefault ()
        
                    const isValidCode = validateCode();
                    if (isValidCode) {
                        if('OTPCredential' in window) {
                            if (typeof ac != 'undefined' && Object.hasOwn(ac, 'abort')) {
                                ac.abort();
                            }
                        }
                        
                        codeField.lockInputs();
                        $form.find ('[type="submit"]').attr ('disabled', true)
                        $form.trigger ('submit')
                    }
                })
            
                // отправить на другой номер
                $changePhone.on ('click', event => {
                    event.preventDefault ()
                    codeField.clearInputs();
                    $form.css ('display', 'none')
                    clearInterval (timer)
                    $form.trigger ('phoneNeedChange')
                })
            
                // результаты отправки формы
                $form
                    .on ('success', (event, response) => {
                        const $success = $root.find ('.js-form-auth-success').clone();
                        $root.empty ()
                        $success.css ('display', 'block').appendTo ($root)

                        // триггер событий аналитики
                        $ (document).trigger ("uiEvent", [
                            {
                                event: 'UI',
                                code: (response.new) ? 'register' : 'login',
                                data: {
                                    userId: response.userId,
                                    mobilePhone: lastPhoneVal
                                }
                            }
                        ]);
                        
                        // Майндбокс вынесен в отдельный триггер
                        if (response.new) {
                            
                            // Регистрация
                            const analyticsEvent = new CustomEvent('ab.analytics.event', {
                                bubbles: true,
                                cancelable: true,
                                detail: {
                                    eventCode: 'authUserRegister',
                                    userId: response.userId,
                                    phone: lastPhoneVal.replaceAll(' ', ''),
                                    consentSubscription: $form.find('[name="consent-subscription"]').is(':checked'),
                                }
                            });
                            document.dispatchEvent(analyticsEvent);
                            
                        } else {
                            
                            // Авторизация
                            const evData = {
                                eventCode: 'authUserLogin',
                                userId: response.userId,
                                phone: lastPhoneVal.replaceAll(' ', ''),
                            };
                            if (response.userEmail) {
                                evData.email = response.userEmail;
                            }
                            
                            const analyticsEvent = new CustomEvent('ab.analytics.event', {
                                bubbles: true,
                                cancelable: true,
                                detail: evData
                            });
                            document.dispatchEvent(analyticsEvent);
                        }

                        // Если в аккаунте нет почты и не было отказа от внесения, после авторизации отрабатывает дозапрос почты
                        if (!response.userEmail && !response.email) {
                            window.emailRequired = true;
                            
                            // Отказ от заполнения игнорируем, если находимся в корзине лекций
                            if (window.isBasketLectures || !response.isRefuseShowEmailPopup) {
                                window.onLoginBubbleToEmailCollector = true;
                            }
                        }
                        
                        window.discountAvailableOnFirstOrder = response.discountAvailableOnFirstOrder;
                        var eUserLoginAfter = jQuery.Event('userLogin:after');
                        window.user.userId = response.userId;
                        $(document).trigger(eUserLoginAfter, {userId: response.userId});
    
                        // отмена перезагрузки страницы при определённых условиях
                        const preventReload = checkPreventReloadOnLogin();
                        if (!preventReload) {
                            // показ сообщения об отправке и редирект
                            setTimeout (() => {
                                $success.css ('opacity', 1)
                                setTimeout (() => {
                                    document.location.reload ();
                                }, 3000)
                            }, 200)
                        }
                    })
                    .on('fail', (event, response) => {
                        codeField.unlockInputs();
                    })
            
                // сохранение телефона в нужные места второй формы при вводе в первой
                $root.on ('phoneEnter', '.js-form-auth-phone', (event, phoneValue) => {
                    lastPhoneVal = phoneValue
                    $form.find ('.js-form-auth-code__phone-output').html (phoneValue)
                    $form.find ('[name="phone"]').val (phoneValue)
                })
                
                // Изменение визуальной части второй формы при успехе в первой
                $root.on ('ab.auth.form.phone.success', '.js-form-auth-phone', (event, dataset) => {
                    // Если аккаунт не найден
                    if (dataset.response.isNewUser) {
                        $form.find ('.js-form-auth-code__title').html ('Похоже, у&nbsp;вас еще нет аккаунта');
                        
                        const $submit = $form.find ('.js-form-auth-code__submit');
                        if ($submit.length > 0) {
                            $submit.find ('[data-role="btn-submit-title"]').html ('Зарегистрироваться');
                            $form.find ('[data-role="form-consent"]').remove ();
                            $('<div class="mod-form__consent" data-role="form-consent"><p class="mod-p">Нажимая на кнопку “Зарегистрироваться”, вы соглашаетесь ' +
                                'с&nbsp;<a href="/terms/" target="_blank" class="link-txt _red">условиями использования</a>.</p>' +
                                '</div>')
                                .insertAfter ($submit);
                        }
                    }
                });
            
                // сохранение кода телефона в нужные места второй формы при вводе в первой
                $root.on ('phoneCodeEnter', '.js-form-auth-phone', (event, phoneCodeValue) => {
                    lastPhoneCodeVal = phoneCodeValue
                    $form.find ('[name="phone-code"]').val (phoneCodeValue)
                })
            
                // успешная отправка первой формы
                $root.on ('success', '.js-form-auth-phone', (event, response) => {
                    $form.removeAttr ('style')
                    $form.find ('[name="code"]').val ('').attr ('readonly', false)
                    $form.find ('[name="token"]').val (response.token)
                    let seconds = parseInt (response.timer)
                    
                    $footer.html(
                        `<p class="mod-p">Мы&nbsp;${(isResend) ? 'повторно ' : ''} отправили код подтверждения.</p>
                         <div class="mod-p mod-p_gray js-form-auth-code__new-code">
                            Новый код можно получить через <span class="js-form-auth-code__timer-output">${globalFunctions.formatSecondsToTime (seconds)}</span>
                         </div>`
                    );
                    const $timer = $footer.find ('.js-form-auth-code__timer-output')
                    timer = setInterval (function () {
                        seconds--
                        if (seconds > 0) {
                            $timer.text (globalFunctions.formatSecondsToTime (seconds))
                        } else {
                            clearInterval (timer)
                            $footer.html ('<a href="#" class="link-txt _red js-form-auth-code__resend">Получить код повторно</a>')
                        }
                    }, 1000)
                    isResend = false;
                })
            
                // отправить ещё один код
                $ (document).on ('click', '.js-form-auth-code__resend', event => {
                    event.preventDefault ()
                    codeField.clearInputs();
                    isResend = true;
                    $form.trigger ('codeNeedResend')
                })
            })
    
            // отправка форм
            $root.find ('.js-form-auth-phone, .js-form-auth-code').each((index, element) => {
                const $form = $(element)
    
                function sendForm () {
                    const ajaxUrl = $form.attr ('data-ajax-url')
                    const formData = $form.serializeArray ()
                    const ajaxData = []
                    $.each (formData, function (k, param) {
                        let paramVal = param.value
                        if (param.value !== '') {
                            paramVal = paramVal.trim ()
                            ajaxData.push ({"name": param.name, "value": encodeURIComponent (paramVal)})
                        }
                    })
        
                    $.ajax ({
                            url: ajaxUrl,
                            type: 'POST',
                            data: JSON.stringify (ajaxData),
                            dataType: 'json'
                        })
                        .done (response => {
                            $form.trigger ((response.success === true) ? 'success' : 'fail', [response])
                        })
                        .fail ((jqXHR, textStatus, errorThrown) => {
                            $form.trigger ('fail')
                        })
                }
                
                $form
                    .on ('submit', event => {
                        event.preventDefault ()
        
                        // когда получаем токен v3, очищаем токен v2, если он в форме есть
                        $form.find ('[name="grecaptchaV2"]').val ('')
                        
                        // если требуется, подгружаем вендорные скрипты для рекапчи и передаём колбэки
                        const grecaptchaKeyV3 = $form.attr ('data-grecaptcha-key-v3');
                        const formSubmit = function() {
                            new Promise ((resolve, reject) => {
                                grecaptcha.ready (() =>
                                    grecaptcha.execute (grecaptchaKeyV3, {action: 'submit'}).then (token => {
                                        resolve (token)
                                    }, reject)
                                )
                            })
                                .then (token => {
                                    // сохраняется токен рекапчи v3 в скрытый инпут
                                    $form.find ('[name="grecaptcha"]').val (token)
                                    sendForm ()
                                })
                                .catch (err => {
                                    $form.trigger ('error', [{errorMessage: 'Не удалось отправить форму'}])
                                    console.log (err)
                                })
                        };
                        if (grecaptchaKeyV3) {
                            if (!ABGrecaptchaLoader.isInWindow()) {
                                ABGrecaptchaLoader.load(
                                    {key: grecaptchaKeyV3},
                                    formSubmit
                                );
                            } else {
                                // если рекапча в форме не требуется (обычно если не переданы ключи), просто вызываем колбэк
                                formSubmit();
                            }
                        } else {
                            sendForm();
                        }
                    })
                    .on ('success phoneNeedChange', (event, response) => {
                        // очищение рекапчи v2 при успешных отправках формы или при попытке отправить на другой номер
                        const $wrap = $root.find ('.js-captcha-wrap')
                        $ ('<div class="captcha-wrap js-captcha-wrap"></div>').insertAfter ($wrap)
                        $wrap.remove ()
                        widgetCaptcha = undefined
                    })
                    .on ('fail', (event, response) => {
                        if (typeof widgetCaptcha !== 'undefined' && widgetCaptcha !== false && response && response.captchaInvalid) {
                            grecaptcha.reset (widgetCaptcha)
                            $form.find ('[name="grecaptcha"]').val('')
                        } else if (typeof grecaptcha != 'undefined' && response && response.captchaInvalid && typeof widgetCaptcha === 'undefined') {
                            const grecaptchaKeyV2 = $form.attr ('data-grecaptcha-key-v2')
                            const $wrap = $root.find ('.js-captcha-wrap')
                            if (typeof grecaptcha != 'undefined' && grecaptchaKeyV2) {
                                $form.find ('[name="grecaptcha"]').val('')
                                widgetCaptcha = grecaptcha.render ($wrap[0], {
                                    'sitekey': grecaptchaKeyV2,
                                    'callback': (token) => {
                                        $form.find ('[name="grecaptchaV2"]').val (token)
                                        sendForm ()
                                    },
                                    'error-callback': () => {
                                        $form.trigger ('error', [{errorMessage: 'Не удалось отправить форму'}])
                                    }
                                });
                            } else {
                                sendForm ()
                            }
                        } else {
                            $form.find ('input').attr ('readonly', false)
                            $form.find ('[type="submit"]').attr ('disabled', false)
                            $form.trigger ('error', [response])
                        }
                    })
            })
        })
    });
    
    
    // -------------------------------------------------
    //
    // --- Старые формы ----
    //
    
    const isDev = globDev;
    
    // --- Моки ---
    const mockUrlFormLoginSubmit = "/ajaxurl/formLoginSubmit";
    let mockCnt = 0;
    
    /*
    -- Формат ответа на аякс --
    success: true | false // флаг успешного выполнения
    message: 'Ошибка' // сообщение об ошибке, если его нужно вывести
    email: "test@test.te" // эмейл юзера, если залогинили и есть эмейл
     */
    $.mockjax ({
        url: mockUrlFormLoginSubmit,
        response: function (settings) {
            let hasCaptcha = false;
            $.each (JSON.parse (settings.data), function (i, v) {
                if (v.name === "grecaptcha") {
                    hasCaptcha = true;
                    return false;
                }
            });
            let respObj = {};
            if (hasCaptcha) {
                respObj.success = mockCnt > 0;
                if (mockCnt === 0) {
                    respObj.captchaInvalid = true;
                }
                mockCnt++;
            } else {
                respObj.success = true;
            }
            
            // const respObj = {
            //     success: false,
            //     message: 'Ошибка<br>Нет данных для доступа'
            // };
            this.responseText = respObj;
        }
    });
    
    
    // показ/скрытие ошибки в инпутах
    
    function fieldShowNotice ($obj, text = 'Некорректное значение', error = false) {
        $obj.trigger('inputError', [{text: text}]);
    }
    
    function fieldCleanNotice ($obj) {
        $obj.trigger('inputResolveErrors');
    }
    
    $ (function () {
        
        // Форма логина (по почте и соцсетям)
        
        const emptyFieldClass = 'ui-input-bordered_state-empty';
        const errorFieldClass = 'ui-input-bordered_state-error';
        
        $ (document).on ("input", ".js-modal-loginForm .ui-input-bordered", function (event) {
            const $input = $(event.target);
            
            if ($input.hasClass(errorFieldClass) || $input.hasClass(emptyFieldClass)) {
                const name = $input.attr ("name");
                const val = $input.val ();
                
                if (name === "password") {
                    if (val.length >= 6) {
                        fieldCleanNotice ($input);
                    }
                    
                } else if (name === "login") {
                    if (val !== "") {
                        fieldCleanNotice ($input);
                    }
                }
            }
        });
        
        $ (document).on ("click", ".js-modal-loginForm__submit", function (e) {
            e.preventDefault ();
            
            const $btn = $ (this);
            const $wrap = $btn.closest (".js-modal-loginForm");
            
            const $inpLogin = $wrap.find ("input[name=\"login\"]");
            const $inpPass = $wrap.find ("input[name=\"password\"]");
            const $inpRemember = $wrap.find ("input[name=\"remember\"]");
            const $inpFavProduct = $wrap.find ("input[name=\"fav-product\"]");
            
            // необходимые поля
            // если их нет, то нечего делать
            
            if ($inpLogin.length === 0 || $inpPass.length === 0) return false;
            
            let er = 0;
            
            const login = $inpLogin.val ();
            const pass = $inpPass.val ();
            const favProduct = $inpFavProduct.val ();
            
            const $notice = $ (".js-modal-login-notice");
            
            if (login === "") {
                fieldShowNotice($inpLogin, 'Заполните это поле');
                er++;
                
            } else if (login.includes ("@")) {
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!re.test (String (login).toLowerCase ().trim ())) {
                    fieldShowNotice($inpLogin, 'Некорректная почта');
                    er++;
                }
            }
            
            if (pass.length < 6) {
                if (!$inpPass.closest (".w-input-text").hasClass ("_error")) {
                    fieldShowNotice ($inpPass, "Не менее 6 символов", true);
                }
                er++;
            }
            
            if (er !== 0 || !$wrap.data ("ajax-url")) return false;
            
            const ajaxData = [
                {name: "login", value: login.trim ()},
                {name: "pass", value: pass.trim ()},
                {name: "remember", value: $inpRemember.is (":checked")}
            ];
            
            if ($notice.length > 0) {
                $notice.html ("");
            }
            if (favProduct) {
                ajaxData.push ({name: "fav-product", value: favProduct})
            }
    
            $btn.attr ("disabled", true);
            $wrap.find('.ui-input-bordered').attr('disabled', true);
            
            // если требуется, подгружаем вендорные скрипты для рекапчи и передаём колбэки
    
            const formSubmit = function() {
                if ($wrap.hasClass ("form-recaptcha") && $wrap.find ("input[name=\"grecaptcha\"]").length === 0) {
                    $wrap.on ("recaptcha:token", function (e, token) {
                        $wrap.append ("<input type=\"hidden\" name=\"grecaptcha\" value=\"" + token + "\">");
                        ajaxData.push ({name: "grecaptcha", value: token});
                        $wrap.trigger ("submit", [ajaxData]);
                    });
                    $wrap.iFormRecaptchaToken ();
                } else {
                    const $greInp = $wrap.find ("input[name=\"grecaptcha\"]");
                    if ($greInp.length > 0) {
                        ajaxData.push ({name: "grecaptcha", value: $greInp.val ()});
                    }
                    $wrap.trigger ("submit", [ajaxData]);
                }
            }
    
            if ($wrap.hasClass('form-recaptcha') && !ABGrecaptchaLoader.isInWindow()) {
                ABGrecaptchaLoader.load(
                    {key: $wrap.attr('data-sitekey-v3')},
                    formSubmit
                );
            } else {
                // если рекапча в форме не требуется (обычно если не переданы ключи), просто вызываем колбэк
                formSubmit();
            }
        });
        
        $ (".js-modal-loginForm").on ("submit", function (e, data = {}) {
            e.preventDefault ();
            
            const $form = $ (this);
            const ajaxUrl = $form.data ("ajax-url");
            const $btn = $form.find (".js-modal-loginForm__submit");
            if ($form.hasClass ("form-recaptcha")) {
                $form.unbind ("recaptcha:token");
                if ($form.find("[name=\"g-recaptcha-response\"]").length > 0) {
                    data.push({name: 'grecaptchaV2', value: $form.find("[name=\"g-recaptcha-response\"]").val()});
                }
            }
            const ajaxData = [];
            $.each (data, function (k, param) {
                ajaxData.push ({"name": param.name, "value": encodeURIComponent (param.value)});
            });
            const params = {
                method: "POST",
                url: (!isDev) ? ajaxUrl : mockUrlFormLoginSubmit,
                data: JSON.stringify (ajaxData),
                dataType: "json"
            };
            
            const promise = $.ajax (params);
            promise
                .done (function (response) {
                    if (response.success === true) {
                        // $btn.attr ("disabled", false);
                        // $form.find('.ui-input-bordered').attr('disabled', false);
                        $form.find ("[data-recaptcha-render]").html ("");
                        $form.trigger ("is:success", [response]);
                    } else if (response.captchaInvalid) {
                        $form.find ("input[name=\"grecaptcha\"]").remove ();
                        const dataNew = [];
                        $.each (data, function (i, val) {
                            if (val.name !== 'grecaptcha' && val.name !== 'grecaptchaV2') {
                                dataNew.push (val);
                            }
                        });
                        $form.iFormRecaptchaRender (dataNew);
                    } else {
                        $btn.attr ("disabled", false);
                        $form.find('.ui-input-bordered').attr('disabled', false);
                        $form.find ("[data-recaptcha-render]").html ("");
                        $form.trigger ("is:fail", [response]);
                    }
                })
                .fail (function (jqXHR, textStatus, errorThrown) {
                    $btn.attr ("disabled", false);
                    $form.find('.ui-input-bordered').attr('disabled', false);
                    $form.find ("[data-recaptcha-render]").html ("");
                    $form.trigger ("is:fail");
                });
        });
        
        
        $ (document).on ("is:success", ".js-modal-loginForm, .js-form-loginForm", function (e, response) {
            $ (document).trigger ("uiEvent", [
                {
                    event: 'UI',
                    code: 'login',
                    data: {
                        email: globalFunctions.escapeStr (response.email),
                        userId: response.userId
                    }
                }
            ]);
    
            // Если в аккаунте нет почты и не было отказа от внесения, после авторизации отрабатывает дозапрос почты
            if (!response.userEmail && !response.email) {
                window.emailRequired = true;
                if (!response.isRefuseShowEmailPopup) {
                    window.onLoginBubbleToEmailCollector = true;
                }
            }
            
            window.discountAvailableOnFirstOrder = response.discountAvailableOnFirstOrder;
            var eUserLoginAfter = jQuery.Event('userLogin:after');
            window.user.userId = response.userId;
            $(document).trigger(eUserLoginAfter, {userId: response.userId});
            
            // отмена перезагрузки страницы при определённых условиях
            const preventReload = checkPreventReloadOnLogin();
            if (!preventReload) {
                // откладываем релоад для верности, чтобы dataLayer успел уйти
                setTimeout(function () {
                    document.location.reload();
                }, 500);
            }
        });
        
        
        $ (document).on ("is:fail", ".js-modal-loginForm", function (e, response) {
            modalError ((response && response.message) ? response.message : "Произошла ошибка. Попробуйте, пожалуйста, позднее.");
        });
        
        $ (document).on ("is:fail", ".js-form-loginForm", function (e, response) {
            const message = (response && response.message) ? response.message : "Произошла ошибка. Попробуйте, пожалуйста, позднее.";
            const errorHTML = `<div class="ui-alert ui-alert_danger form-login__error">${message}</div>`;
            $(e.target).find (".js-form-login-notice").html(errorHTML);
        });
        
        
        // вывести ошибку в модалке
        
        function modalError (message) {
            const $wrapper = $.fancybox.getInstance ().current.$content.find (".simplebar-content-wrapper");
            const $content = $wrapper.find (".simplebar-content");
            const errorHTML = `<div class="ui-alert ui-alert_danger modal-login__error">${message}</div>`;
            $content.find (".js-modal-login-notice").html(errorHTML);
        }
    });
    
    $ (function () {
        // отдельная страница авторизации
    
        const emptyFieldClass = 'ui-input-bordered_state-empty';
        const errorFieldClass = 'ui-input-bordered_state-error';
        
        $ ('.js-auth-page').each ((index, element) => {
            const $root = $ (element)
            // переключение форм на отдельной странице
            $root.find ('.js-auth-page__toggle').on ('click', (event) => {
                event.preventDefault ()
                $ ('.js-auth-page__form').toggleClass ('auth-page__form_visible')
            })
        })
    
        // старая форма логина на отдельной странице
        $ (document).on ("input", ".js-form-loginForm .ui-input-bordered", function (event) {
            const $input = $(event.target);
            
            if ($input.hasClass(errorFieldClass) || $input.hasClass(emptyFieldClass)) {
                const name = $input.attr ("name");
                const val = $input.val ();
                
                if (name === "password") {
                    if (val.length >= 6) {
                        fieldCleanNotice ($input);
                    }
                    
                } else if (name === "login") {
                    if (val !== "") {
                        fieldCleanNotice ($input);
                    }
                }
            }
        });
        
        $ (document).on ("click", ".js-form-loginForm__submit", function (e) {
            e.preventDefault ();
            
            const $btn = $ (this);
            const $wrap = $btn.closest (".js-form-loginForm");
            
            const $inpLogin = $wrap.find ("input[name=\"login\"]");
            const $inpPass = $wrap.find ("input[name=\"password\"]");
            const $inpRemember = $wrap.find ("input[name=\"remember\"]");
    
            const $notice = $ (".js-form-login-notice");
            
            // необходимые поля
            // если их нет, то нечего делать
            
            if ($inpLogin.length === 0 || $inpPass.length === 0) return false;
            
            let er = 0;
            
            const login = $inpLogin.val ();
            const pass = $inpPass.val ();
            
            if (login === "") {
                if (!$inpLogin.closest (".w-input-text").hasClass ("_error")) {
                    fieldShowNotice ($inpLogin, 'Заполните это поле');
                }
                er++;
                
            } else if (login.includes ("@")) {
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!re.test (String (login).toLowerCase ().trim ())) {
                    fieldShowNotice ($inpLogin, 'Некорректная почта');
                    er++;
                }
            }
            
            if (pass.length < 6) {
                if (!$inpPass.closest (".w-input-text").hasClass ("_error")) {
                    fieldShowNotice ($inpPass, "Не менее 6 символов", true);
                }
                er++;
            }
            
            if (er !== 0 || !$wrap.data ("ajax-url")) return false;
            
            const ajaxData = [
                {name: "login", value: login.trim ()},
                {name: "pass", value: pass.trim ()},
                {name: "remember", value: $inpRemember.is (":checked")}
            ];
    
            if ($notice.length > 0) {
                $notice.html ("");
            }
    
            $btn.attr ("disabled", true);
            $wrap.find('.ui-input-bordered').attr('disabled', true);
    
            // если требуется, подгружаем вендорные скрипты для рекапчи и передаём колбэки
            const formSubmit = function() {
                if ($wrap.hasClass ("form-recaptcha") && $wrap.find ("input[name=\"grecaptcha\"]").length === 0) {
                    $wrap.on ("recaptcha:token", function (e, token) {
                        $wrap.append ("<input type=\"hidden\" name=\"grecaptcha\" value=\"" + token + "\">");
                        ajaxData.push ({name: "grecaptcha", value: token});
                        $wrap.trigger ("submit", [ajaxData]);
                    });
                    $wrap.iFormRecaptchaToken ();
                } else {
                    const $greInp = $wrap.find ("input[name=\"grecaptcha\"]");
                    if ($greInp.length > 0) {
                        ajaxData.push ({name: "grecaptcha", value: $greInp.val ()});
                    }
                    $wrap.trigger ("submit", [ajaxData]);
                }
            };
            
            if ($wrap.hasClass('form-recaptcha') && !ABGrecaptchaLoader.isInWindow()) {
                ABGrecaptchaLoader.load(
                    {key: $wrap.attr('data-sitekey-v3')},
                    formSubmit
                );
            } else {
                // если рекапча в форме не требуется (обычно если не переданы ключи), просто вызываем колбэк
                formSubmit();
            }
        });
        
        $(".js-form-loginForm").on("submit", function (e, data = {}) {
            e.preventDefault ();
            
            const $form = $ (this);
            const ajaxUrl = $form.data ("ajax-url");
            const $btn = $form.find (".js-form-loginForm__submit");
            if ($form.hasClass ("form-recaptcha")) {
                $form.unbind ("recaptcha:token");
                if ($form.find("[name=\"g-recaptcha-response\"]").length > 0) {
                    data.push({name: 'grecaptchaV2', value: $form.find("[name=\"g-recaptcha-response\"]").val()});
                }
            }
            const ajaxData = [];
            $.each (data, function (k, param) {
                ajaxData.push ({"name": param.name, "value": encodeURIComponent (param.value)});
            });
            const params = {
                method: "POST",
                url: (!isDev) ? ajaxUrl : mockUrlFormLoginSubmit,
                data: JSON.stringify (ajaxData),
                dataType: "json"
            };
            
            const promise = $.ajax (params);
            promise
                .done (function (response) {
                    if (response.success === true) {
                        // $btn.attr ("disabled", false);
                        // $form.find('.ui-input-bordered').attr('disabled', false);
                        $form.find ("[data-recaptcha-render]").html ("");
                        $form.trigger ("is:success", [response]);
                    } else if (response.captchaInvalid) {
                        $form.find ("input[name=\"grecaptcha\"]").remove ();
                        const dataNew = [];
                        $.each(data, function (i, val) {
                            if (val.name !== 'grecaptcha' && val.name !== 'grecaptchaV2') {
                                dataNew.push(val);
                            }
                        });
                        $form.iFormRecaptchaRender (dataNew);
                    } else {
                        $btn.attr ("disabled", false);
                        $form.find('.ui-input-bordered').attr('disabled', false);
                        $form.find ("[data-recaptcha-render]").html ("");
                        $form.trigger ("is:fail", [response]);
                    }
                })
                .fail (function (jqXHR, textStatus, errorThrown) {
                    $btn.attr ("disabled", false);
                    $form.find('.ui-input-bordered').attr('disabled', false);
                    $form.find ("[data-recaptcha-render]").html ("");
                    $form.trigger ("is:fail");
                });
        });
    });
    
    
    $ (function () {
        
        // Форма восстановления пароля
    
        // ввод в поле пароля разлочивает поле "Повторите пароль"
        $ (document).on ("input", ".js-form-register__pass", function (e) {
            const $pass = $ (this);
            const $passRepeat = $pass.closest (".js-i-form").find (".js-form-register__passRepeat");
        
            const val = $pass.val ();
        
            if ($passRepeat.length > 0) {
                $passRepeat.prop ("disabled", (val === ""));
            }
        });
    
        // проверка на совпадение паролей при вводе в "Повторите пароль"
        $ (document).on ("input", ".js-form-register__passRepeat", function (e) {
            const $passRepeat = $ (this);
            const $pass = $passRepeat.closest (".js-i-form").find (".js-form-register__pass");
        
            // если какого-то поля нет
            if ($pass.length === 0 || $passRepeat.length === 0) return false;
        
            const passVal = $pass.val ();
            const passRepeatVal = $passRepeat.val ();
        
            if (passVal === "") return false;
        
            fieldCleanNotice ($passRepeat);
        
            if (passVal !== passRepeatVal) {
                fieldShowNotice ($passRepeat, "Пароли не совпадают", true);
            }
        });
        
        $ (".js-change-password").each (function () {
            const $form = $ (this).find (".js-form-change-password");
            
            $form.on ("is:success", function (evt, response) {
                evt.preventDefault();
                if (response.urlRedirect) {
                    window.location = response.urlRedirect
                }
                else {
                    $ (document).trigger ('is:errorModal', {
                        title: "Пароль изменен!",
                        text: "Вы успешно изменили пароль от учетной записи.",
                        btnText: 'Продолжить'
                    });
                }
            });
            
            $form.on ("is:fail", function (evt, response) {
                evt.preventDefault();
                let message = response && response.message  ? response.message : "Что-то пошло не так. Попробуйте позже.";
                $ (document).trigger ('is:errorModal', {title: "Произошла ошибка!", text: message});
            });
        });
        
        
        // Форма "Забыли пароль?"
        
        $ (document).on ("is:success", ".js-form-passRestore", function (e, response) {
            const $form = $ (this);
            const $notice = $ (".js-modal-passRestore-notice");
            const $success = $ (".js-modal-passRestore-success");
            
            $form.remove ();
            
            if ($notice.length > 0) {
                $notice.html("");
            }
            
            let messEmail = "";
            
            if (response && response.email) {
                messEmail = " " + String (response.email);
            }
            
            let message = `Вам отправлено письмо на&nbsp;почту${messEmail} с&nbsp;дальнейшими инструкциями.`;
            
            if ($success.length > 0) {
                $success.removeClass ("_hidden").find (".js-modal-passRestore-success__text").html (message);
            }
        });
        
        $ (document).on ("is:fail", ".js-form-passRestore", function (e, response) {
            const $notice = $ (".js-modal-passRestore-notice");
            if ($notice.length === 0) return false;
            
            const message = (response && response.message) ? response.message : "Произошла ошибка. Попробуйте, пожалуйста, позднее.";
            const errorHTML = `<div class="ui-alert ui-alert_danger form-passRestore__error-item">${message}</div>`;
            $notice.html(errorHTML);
            
            const $wrapper = $.fancybox.getInstance ().current.$content.find (".simplebar-content-wrapper");
            const $content = $wrapper.find (".simplebar-content");
            $wrapper[0].scrollTo ({
                top: $content.outerHeight (),
                behavior: "smooth"
            });
        });
    });
} ());


// Механизм дозапроса почты при авторизации

document.addEventListener('DOMContentLoaded', function() {
    
    if (!user.userLogged) {
        const onSuccess = function() {
            window.onLoginBubbleToEmailCollector = false;
            if (window.onLoginBubbleToBasket) {
                $(document).trigger('userLogin:after', [window.user.userId]);
            } else {
                setTimeout(function() {
                    location.reload();
                }, 3000);
            }
        };
        
        const onRefuse = function() {
            setTimeout(function() {
                location.reload();
            }, 3000);
        };
        
        let options = {
            contentType: 'notify',
            actionType: 'collect',
            onSuccess:  onSuccess,
            onRefuse:   onRefuse
        };
        
        const collector = new CollectEmail(options);
        
        // Закрытие уведомления
        document.addEventListener('close.toast', function(event) {
            if (event.detail.target.id === 'collectEmailToast') {
                collector.sendRefuseRequest();
                collector.showRefuse();
            }
        });
        
        // Перехват события на авторизации
        $(document).on('userLogin:after',function (event) {
            event.preventDefault ();
    
            if (!window.onLoginBubbleToGiftBuy && !window.onLoginBubbleToSubscription && window.onLoginBubbleToEmailCollector && !window.isBasketLectures) {
                collector.show();
            } 
        });
    }
});
